import { computed, Injectable, signal } from '@angular/core';
import { EnComponentState } from '../enums/component-state.enum';
import { ComponentState } from '../interfaces/component-state.interface';

@Injectable({
  providedIn: 'root'
})
export class ComponentStateService implements ComponentState {
  readonly loading = signal(false);
  readonly lookup = signal(false);
  readonly error = signal(false);
  readonly idle = signal(true);

  readonly current = computed<EnComponentState>(() => {
    if (this.isLoading()) return EnComponentState.LOADING;
    if (this.isLookup()) return EnComponentState.LOOKUP;
    if (this.hasError()) return EnComponentState.ERROR;
    return EnComponentState.IDLE;
  });

  setState(state: EnComponentState, value: boolean): void {
    this.reset();
    switch (state) {
      case EnComponentState.LOADING:
        this.loading.set(value);
        break;
      case EnComponentState.LOOKUP:
        this.lookup.set(value);
        break;
      case EnComponentState.ERROR:
        this.error.set(value);
        break;
      case EnComponentState.IDLE:
        this.idle.set(value);
        break;
    }
  }

  getState(state: EnComponentState): boolean {
    return this[state]();
  }

  isLoading(): boolean {
    return this.loading();
  }

  isLookup(): boolean {
    return this.lookup();
  }

  hasError(): boolean {
    return this.error();
  }

  isIdle(): boolean {
    return this.idle();
  }

  reset(): void {
    this.loading.set(false);
    this.lookup.set(false);
    this.idle.set(false);
    this.error.set(false);
  }
}
